import { action } from 'mobx';
import moment from 'moment';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {PatientService} from 'application/patient/services';
import _ from "lodash";

@applicationContext
class PatientPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            name: 'patient',
            autoInit: true,
            id: id,
            actions: () => {
                const service = new PatientService(rootStore.application.baasic.apiClient);        
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed: 'PatientAreaOfCares,AccountRep,Branch' });
                        response.data.patientGeneralInfo.birthDate = moment(response.data.patientGeneralInfo.birthDate).format("MM/DD/YYYY");
                        response.data.patientInsuranceInfo.payors = _.filter(response.data.patientInsuranceInfo.payors, item => {
                            return (item.payorLevel != 'Patient' && item.payorPolicyInfo.effectiveEndDate == null);
                        });
                        return response.data;
                    
                    }
                }
            }
        });

        this.setTitle(rootStore.routerStore.routerState.params.firstName, rootStore.routerStore.routerState.params.lastName);
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }

    @action.bound
    setTitle(firstName, lastName) {
		this.rootStore.viewStore.setNavigationOptions({
			title:  firstName + ' ' + lastName
		});
		
	}
}

export default PatientPreviewViewStore;
